__turbopack_context__.v({
  "body": "style-module-scss-module__6-h-jG__body",
  "section": "style-module-scss-module__6-h-jG__section",
  "title": "style-module-scss-module__6-h-jG__title",
  "wrapper": "style-module-scss-module__6-h-jG__wrapper",
});
